import { HelperCep } from "./helper-cep";
import { HelperCnpjInformaton } from "./helper-cnpj-information";
import { extractNumbers } from "./helper-string";

const setAddressFieldValues = (
  el: any,
  response: any,
  prefix: string,
): void => {
  el.setFieldValue(`${prefix}City`, response?.city ?? "");
  el.setFieldValue(`${prefix}Neighborhood`, response?.neighborhood ?? "");
  el.setFieldValue(`${prefix}Street`, response?.street ?? "");
  el.setFieldValue(`${prefix}State`, response?.state ?? "");
  el.setFieldValue(`${prefix}City`, response?.city ?? "");
};

const setCompanyInformationFieldValues = (
  el: any,
  response: any
): void => {
  el.setFieldValue("socialReason", response?.company.name ?? "");
  el.setFieldValue("fantasyName", response?.company.alias ?? "");
  el.setFieldValue("companyEmail", response?.emails[0]?.address ?? "");
  el.setFieldValue("companyPhone", `${response?.phones[0]?.area}${response?.phones[0]?.number}` ?? "");
  // el.setFieldValue("isMei", response?.company?.size?.acronym === "ME");
};

export const handleCepChange = async (
  data: any,
  el: any,
  prefix: string,
): Promise<void> => {
  const cep = extractNumbers(data);
  if (HelperCep.isValidCep(cep)) {
    const response = await HelperCep.getAdressByCep(cep);
    setAddressFieldValues(el, response, prefix);
  }
};

export const handleCnpjChange = async (
  data: any,
  el: any
): Promise<void> => {
  console.log("TESTE");
  const cnpj = extractNumbers(data);
  if (HelperCnpjInformaton.isValidCnpj(cnpj)) {
    const response = await HelperCnpjInformaton.getInformationCnpj(cnpj);
    setCompanyInformationFieldValues(el, response);
  }
};

export const handleNoStackChange = (
  value: any,
  el: any,
  stacks: any[],
): void => {
  const noStackDescription = "Não desejo informar";
  const noStackId = stacks.find(
    (stack) => stack.description === noStackDescription,
  )?.id;

  if (value[0] === "true" && noStackId) {
    el.setFieldValue("otherStack", "");
    el.setFieldValue("stacks", [noStackId]);
  } else if (noStackId) {
    el.setFieldValue(
      "stacks",
      el.values.stacks.filter((stackId: any) => stackId !== noStackId),
    );
  }
};

export const hasCertificate = (data: any): boolean =>
  data?.certificateFile && data?.certificatePassword && data?.certificateEmail;
